import type { ActionType, ProColumns } from '@ant-design/pro-table';
import { DatePicker, Space } from 'antd';
import { useRef, useCallback, useState } from 'react';
import { PageContainer, useAPI } from '@fregata/shared';
import { ProTable } from '@ant-design/pro-table';
import OutletLayout from 'layouts/OutletLayout';
import moment from 'moment';
import { disabledDate } from 'utils/disableDate';

const AppDaily = () => {
  const ref = useRef<ActionType>();
  const { api } = useAPI();

  // const [userCount, setUserCount] = useState<any>();
  const [recordCount, setRecordCount] = useState<any>();

  let baseColumns: ProColumns[] = [
    {
      title: '应用名称',
      dataIndex: 'appName',
      search: { transform: (v) => ({ queryName: v }) },
    },
    {
      title: '订阅用户数',
      dataIndex: 'dyCount',
      hideInSearch: true,
      hideInForm: true,
    },
    {
      title: '访问次数',
      dataIndex: 'count',
      hideInSearch: true,
      hideInForm: true,
    },
    {
      title: '统计时间',
      renderText: () => moment().format('YYYY-MM-DD HH:mm:ss'),
      hideInSearch: true,
      hideInForm: true,
    },
    {
      title: '统计时间',
      dataIndex: 'createTime',
      valueType: 'dateRange',
      hideInTable: true,
      hideInForm: true,
      search: {
        transform: (value) => {
          return {
            startDate: value[0],
            endDate: value[1],
          };
        },
      },
      formItemProps: () => {
        return {
          initialValue: [moment().subtract(1, 'days'), moment()],
        };
      },
      renderFormItem: () => {
        return <DatePicker.RangePicker placeholder={['请选择', '请选择']} />;
      },
    },
  ];

  const requestData = useCallback(
    async ({ current, ...params } = {}) => {
      return api('/api/app-site/platform_system_manage/sr/page_app_log_statistics_list', {
        handleResponse2Data: false,
        params: { pageNum: current, ...params },
      }).then((resp: any) => {
        setRecordCount(resp.data.total);
        let returnData = { data: resp.data?.list, success: resp.message, total: resp.data?.total };
        return returnData;
      }) as any;
    },
    [api]
  );

  return (
    <>
      <PageContainer isBody>
        <ProTable
          dateFormatter='string'
          rowKey='name'
          scroll={{ x: 1600 }}
          columns={baseColumns}
          actionRef={ref}
          request={requestData}
          tableAlertRender={false}
          tableAlertOptionRender={false}
          editable={{
            type: 'multiple',
          }}
          search={{
            labelWidth: 'auto',
          }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: 10, // 默认10条/页
          }}
          headerTitle={
            <Space>
              <span>船海智云平台应用日活跃统计列表</span>
              <span style={{ color: '#1b62b7' }}>
                {/* [总用户数：{userCount}, 总记录数：{recordCount}] */}
                [总记录数：{recordCount}]
              </span>
            </Space>
          }
        />
      </PageContainer>

      <OutletLayout context={{ reload: ref.current?.reload }} />
    </>
  );
};

export default AppDaily;
